const DesktopBottom = () => {
  return <div></div>
}

export { DesktopBottom }
